<template>
    <div>
        <card-header title="New Contact" icon="fa-plus"/>

        <card-body>
            <contact-form :contact="newContact"/>
        </card-body>

        <card-footer class="pt-3 pb-3 has-text-right">
            <b-button type="is-primary" size="is-small" :disabled="!hasName" @click="submit">
                <i class="fas fa-plus mr-3"></i>{{attaching ? 'Create &amp; Attach' : 'New Contact'}}
            </b-button>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from '../../TIER/components/CardHeader';
    import CardFooter from "../../TIER/components/CardFooter";
    import CardBody from "../../TIER/components/CardBody";
    import ContactForm from "@/cards/contacts/ContactForm";

    import {client as http} from '../../http_client';
    import {companyFromKey} from "@/components/contact_meta";

    /**
     * Creates a directory contact, and attaches it in the same call when
     * opened from an entity's Contacts tab (entityType/entityId props). The
     * attach endpoint takes the whole new record nested under `contact`, so
     * this is one request, not create-then-attach.
     *
     * Also registered as 'new-directory-contact': opened from a type or
     * company card in the directory drill-down, the type/companyKey props
     * pre-fill the form so the new contact lands where the user already is.
     */
    export default {
        props: ['card', 'props'],
        components: {ContactForm, CardBody, CardFooter, CardHeader},
        data: function () {
            return {
                // Match the column default rather than leaving type unset.
                newContact: {
                    type: this.props.type || 'other',
                    company: this.props.companyKey ? companyFromKey(this.props.companyKey) : undefined
                }
            };
        },
        computed: {
            attaching: function () {
                return !!(this.props.entityType && this.props.entityId);
            },
            // The server requires one of company/name -- mirror it here so the
            // button is disabled rather than the save 400ing.
            hasName: function () {
                return !!((this.newContact.company || '').trim() || (this.newContact.name || '').trim());
            }
        },
        methods: {
            submit() {
                this.$emit('loading', true);

                const request = this.attaching
                    ? http.post(`/api/contacts/entity/${this.props.entityType}/${this.props.entityId}`,
                        {contact: this.newContact, role: this.props.role || null}, {force: true})
                    : http.post('/api/contacts', this.newContact, {force: true});

                request.then(() => {
                    this.$saveAlert(false);
                    // Every level of the drill-down counts or lists contacts.
                    this.$reloadCard('contacts');
                    this.$reloadCard('contact-type');
                    this.$reloadCard('contact-company');
                    this.$closeCard(this.card);
                }).catch(() => {
                    console.log('An error occurred.');
                    this.$emit('loading', false);
                });
            }
        },
        mounted() {
            this.$saveAlert(true, 'Are you done creating this new contact? Unsaved changes will be lost.');
        }
    };
</script>
